module.exports = __webpack_public_path__ + "assets/1b5c934129f69eab37075f421756d56e.svg";